!function(global){
	function Events(){
		//готово к наследованию
	}

	Events.prototype.on = function(name, callback, context){
		var nameArray = name.split(' '),
			events;

		if(_.isArray(nameArray)){
			for(var i = 0, l = nameArray.length; i < l; i++){
				this._events || (this._events = {});
				events = this._events[nameArray[i]] || (this._events[nameArray[i]] = []);
				events.push({callback: callback, context: context, ctx: context || this});
			}
		}else{
			this._events || (this._events = {});
			events = this._events[name] || (this._events[name] = []);
			events.push({callback: callback, context: context, ctx: context || this});
		}

		return this;
	};

	Events.prototype.once = function(name, callback, context){
		var that = this,
			once = _.once(function() {
				that.off(name, once);
				callback.apply(this, arguments);
			});

		once._callback = callback;
		return this.on(name, once, context);
	};

	Events.prototype.trigger = function(name){
		if (!this._events) return this;
		var args = Array.prototype.slice.call(arguments, 1);

		var events = this._events[name],
			allEvents = this._events.all;

		if(events){
			this.triggerEvents(events, args);
		}
		if(allEvents){
			this.triggerEvents(allEvents, arguments);
		}

		return this;
	};

	//оптимизированая функция для вызова
	//до 3-х аргументов работает быстрее call
	//более 3-х apply
	Events.prototype.triggerEvents = function(events, args) {
		var ev,
			i = -1,
			l = events.length,
			a1 = args[0],
			a2 = args[1],
			a3 = args[2];

		switch (args.length) {
			case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
			case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
			case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
			case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
			default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
		}
	};


	Events.prototype.off = function(name, callback, context) {
		var retain, ev, events, names, i, l, j, k;

		if (!this._events) return this;

		if (!name && !callback && !context) {
			this._events = {};
			return this;
		}

		names = name ? [name] : _.keys(this._events);
		for (i = 0, l = names.length; i < l; i++) {
			name = names[i];
			if (events = this._events[name]) {
				this._events[name] = retain = [];
				if (callback || context) {
					for (j = 0, k = events.length; j < k; j++) {
						ev = events[j];
						if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
							(context && context !== ev.context)) {
							retain.push(ev);
						}
					}
				}
				if (!retain.length) delete this._events[name];
			}
		}

		return this;
	};

	//сеттер для вызова ивента "изменилось состояние", если состояние изменилось
	Events.prototype.set = function(name, value){
		if(this[name] === value){
			return this;
		}
		this[name] = value;
		this.trigger(name + ':change', value, this);
		return this;
	};


	global.Events = Events;

}(this);